var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("התוכנית הישנה הסתיימה")]),_c('p',[_vm._v("אנחנו מקווים שנהניתן! אתן מוזמנות להירשם לתוכנית החדשה שלנו, בריאה וחטובה.")]),_c('a',{attrs:{"href":"/"}},[_vm._v("להרשמה")])])
}]

export { render, staticRenderFns }